/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Cost_AccountInputs */

const en_reference_field_cost_account = /** @type {(inputs: Reference_Field_Cost_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account of the lines that are not goods`)
};

/**
* | output |
* | --- |
* | "Account of the lines that are not goods" |
*
* @param {Reference_Field_Cost_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_cost_account = /** @type {((inputs?: Reference_Field_Cost_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Cost_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_cost_account(inputs)
});